import { Action, PageState } from "../../components/TypeDefinitions";

export function closeEditor<
  E extends Extract<
    Action,
    {
      type: "closeEditor";
    }
  >
>(action: E, draft: PageState): void {
  draft.editingFieldId = null;
}
